import { render, staticRenderFns } from "./DetectTicket.vue?vue&type=template&id=ac6d3026&scoped=true"
import script from "./DetectTicket.vue?vue&type=script&lang=js"
export * from "./DetectTicket.vue?vue&type=script&lang=js"
import style0 from "./DetectTicket.vue?vue&type=style&index=0&id=ac6d3026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6d3026",
  null
  
)

export default component.exports